import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

Swiper.use([Autoplay]);

export function init() {
  new Swiper(document.getElementById('benefit-slide'), {
    autoplay: {
      delay: 1000,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
    slidesPerView: 5,
    direction: 'vertical',
    loop: true,
    height: 400,
  });

  function horizontalScroll() {
    const sticky = document.querySelector('.con-5 .inner .left');
    const stickyParent = sticky.parentElement;
    const stickyPosition = sticky.getBoundingClientRect().top;

    if (stickyPosition !== 0) {
      return;
    } else {
      const scrolled = stickyParent.getBoundingClientRect().top * -1;
      const wrapper = document.querySelector('.con-5 .inner .left');
      const page = Math.floor(scrolled / window.innerHeight) + 1;

      if (page === 4) return;

      for (const d of wrapper.querySelectorAll('[data-step]')) {
        const dom = d as HTMLElement;

        if (dom.dataset.step === String(page)) {
          dom.style.display = 'block';
        } else {
          dom.style.display = 'none';
        }
      }

      if (!wrapper.classList.contains(`step${page}`)) {
        wrapper.classList.remove('step1', 'step2', 'step3');
        wrapper.classList.add(`step${page}`);
      }
    }
  }

  document.addEventListener('scroll', horizontalScroll);
}
